import { observer } from 'mobx-react';
import * as React from 'react';

export const buildTitle = (...parts: (string | undefined)[]) =>
    parts.filter(Boolean).join(' | ');

interface BrowserTitleProps {
    title: string;
}

export const BrowserTitle = observer((props: BrowserTitleProps) => {
    React.useEffect(() => {
        document.title = props.title;
    }, [props.title]);

    return null;
});
